import styled from 'styled-components';
import React from 'react';
import Icon from '@/components/core/Icon/Icon';
import Typography from '@/components/core/Typography';
import { Flex } from '@/components/Flex';

type Props = {
    children: React.ReactNode;
    severity: 'success' | 'info' | 'warning' | 'error';
    customIcon?: React.ReactNode;
    className?: string;
}

const Wrapper = styled.div<{$variant: string}>`
  display: flex;
  color: ${({ theme, $variant }) => {
        if ($variant === 'error') {
            return theme.colors.palette.red_300;
        }

        if ($variant === 'warning') {
            return theme.colors.palette.grey_700;
        }

        return 'black';
    }};
  background-color: ${({ theme, $variant }) => {
        if ($variant === 'error') {
            return theme.colors.palette.red_100;
        }

        if ($variant === 'warning') {
            return theme.colors.palette.yellow_100;
        }

        return 'white';
    }};
  padding: ${({ theme }) => theme.spacing['2xs']};
  border-radius: ${({ theme }) => theme.extras.radius.sm};
  gap: 6px;

    ${Icon} {
        color: ${({ theme, $variant }) => {
        if ($variant === 'error') {
            return theme.colors.palette.red_400;
        } else if ($variant === 'warning') {
            return theme.colors.palette.yellow_400;
        }
    }
}
`;

const IconBlock = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 2px;
`;

const AlertWithIcon = ({ children, severity, customIcon, className }: Props) => {
    return (
        <Wrapper $variant={severity} className={className}>
            <IconBlock>
                {customIcon ? customIcon : <Icon name='alert-triangle-light' size='sm' />}
            </IconBlock>
            <Flex>
                <Typography variant='uiType' size='xs' modifier='R'>
                    {children}
                </Typography>
            </Flex>
        </Wrapper>
    );
};

export default AlertWithIcon;
